import React from "react"
import { useLocation } from "react-router-dom"

import "./index.scss"
import { Title, Container, DurationInput, Select, Text } from "components/Form"
import { DateTime, Duration } from "luxon"

export default function PeopleSetup({
  setuptime,
  setSetuptime,
  isDraft,
  perSampleDuration,
  setPerSampleDuration,
  disabled,
  competenceGroups,
  allowedGroupIds,
  setAllowedGroupIds,
  startDate,
  setStartDate,
  startTime,
  setStartTime,
  teamTimeZone,
  task,
}) {
  const location = useLocation()
  const isAssetView = location.pathname.includes("/asset-view")
  return (
    <div className="container-compartment">
      <p>People Setup</p>
      {isAssetView && (
        <>
          <Container>
            <Title>From date</Title>
            <Text
              type="date"
              required
              disabled={disabled}
              value={startDate ? startDate.toFormat("yyyy-MM-dd") : ""}
              onChange={(value) => {
                if (!value) {
                  setStartDate(undefined)
                  return
                }
                try {
                  const newDate = DateTime.fromFormat(value, "yyyy-MM-dd").setZone(teamTimeZone, { keepLocalTime: true })
                  setStartDate(newDate)
                } catch (error) {
                  // Handle invalid date format
                }
              }}
            />
            <Title>From time (HH:MM)</Title>
            <DurationInput
              disabled={disabled}
              value={startTime}
              onChange={setStartTime}
              required
              isTime
            />
          </Container>
          <Container>
            <Title>To date</Title>
            <Text
              type="date"
              required
              disabled
              value={DateTime.fromISO(task.end).setZone(teamTimeZone).toFormat("yyyy-MM-dd")}
            />
            <Title>To time (HH:MM)</Title>
            <DurationInput
              disabled
              value={
                Duration.fromObject({
                  hours: DateTime.fromISO(task.end).setZone(teamTimeZone).hour,
                  minutes: DateTime.fromISO(task.end).setZone(teamTimeZone).minute,
                })
            }
            />
          </Container>
        </>
      )}
      <Container>
        <Title>
          Setuptime (HH:MM)<div className="red-text">*</div>
        </Title>
        <DurationInput value={setuptime} onChange={setSetuptime} required={!isDraft} />
      </Container>
      <Container>
        <Title>Per sample duration (HH:MM:SS)</Title>
        <DurationInput required={!isDraft} withSeconds value={perSampleDuration} onChange={setPerSampleDuration} />
      </Container>
      <Container>
        <Title>
          Allowed Competence Groups<div className="red-text">*</div>
        </Title>
        <Select
          name="Allowed Competence Groups"
          disabled={disabled}
          required={!isDraft}
          collection={Object.values(competenceGroups).sort((a, b) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
            return 0
          })}
          value={allowedGroupIds}
          onChange={setAllowedGroupIds}
          menuPosition="fixed"
        />
      </Container>
    </div>
  )
}
